// extracted by mini-css-extract-plugin
export default {"btn-apply":"ManageComercialTable_btn-apply__MhIXF"};